import { useState } from 'react';
import './styles.css';
import Icons from '../Icon/icons';
import { useAccessibility } from '../../shared/context/a11y-context';

interface AccessibilityControlsProps {
  onFontSizeChange: (level: number) => void;
}

const AccessibilityControls = ({ onFontSizeChange }: AccessibilityControlsProps) => {
  const { screenReaderEnabled, toggleScreenReader, announceMessage } = useAccessibility();
  const [fontSizeLevel, setFontSizeLevel] = useState(0);

  const increaseFontSize = () => {
    const newLevel = Math.min(fontSizeLevel + 1, 4);
    setFontSizeLevel(newLevel);
    onFontSizeChange(newLevel);
    announceMessage(`Fonte aumentada. Nível ${newLevel} de 4`, 'polite');
  };

  const decreaseFontSize = () => {
    const newLevel = Math.max(fontSizeLevel - 1, 0);
    setFontSizeLevel(newLevel);
    onFontSizeChange(newLevel);
    announceMessage(`Fonte diminuída. Nível ${newLevel} de 4`, 'polite');
  };

  const handleToggleScreenReader = () => {
    toggleScreenReader();
  };

  return (
    <div className="accessibility-controls">
      <button
        onClick={handleToggleScreenReader}
        className={`screen-reader-btn ${screenReaderEnabled ? 'active' : ''}`}
        title={screenReaderEnabled ? 'Desativar leitor de tela' : 'Ativar leitor de tela'}
        aria-label={screenReaderEnabled ? 'Desativar leitor de tela' : 'Ativar leitor de tela'}
        aria-pressed={screenReaderEnabled}
      >
        <Icons 
          iconName={screenReaderEnabled ? "RecordVoiceOver" : "VoiceOverOff"} 
          addTooltip={screenReaderEnabled ? "Leitor Ativado" : "Leitor Desativado"}
          color={screenReaderEnabled ? "#3a8d8e" : "#666"} 
          fontSize={24} 
        />
      </button>

      <div
        className="font-size-group"
        aria-label="Controles de tamanho da fonte"
      >
        <button
          onClick={decreaseFontSize}
          className="font-size-btn"
          title="Diminuir fonte"
          disabled={fontSizeLevel === 0}
          aria-label="Diminuir tamanho da fonte"
        >
          A-
        </button>

        <span className="font-size-divider" aria-hidden="true" />

        <button
          onClick={increaseFontSize}
          className="font-size-btn"
          title="Aumentar fonte"
          disabled={fontSizeLevel === 4}
          aria-label="Aumentar tamanho da fonte"
        >
          A+
        </button>
      </div>
    </div>
  );
};

export default AccessibilityControls;
